export const removeNonDigits = (value: string) => value.replace(/\D/g, '');
